// eslint-disable-next-line no-shadow
enum DeviceLayout {
  PHONE = 'phone',
  DESKTOP = 'desktop',
}

export default DeviceLayout;
